import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, } from "react";
import useService from "./useService";
import InstitutionService from "../../Services/Institution.service";
const InstitutionContext = createContext({
    institutionAcronym: () => null,
});
export const InstitutionContextProvider = ({ children, }) => {
    const [institutionAcronymState, loadInstitutionAcronym] = useService(InstitutionService.getInstitutionAcronym);
    useEffect(() => {
        loadInstitutionAcronym();
    }, [loadInstitutionAcronym]);
    const _institutionAcronym = useMemo(() => () => {
        var _a;
        return (_a = institutionAcronymState.data) !== null && _a !== void 0 ? _a : null;
    }, [institutionAcronymState.data]);
    const value = useMemo(() => ({
        institutionAcronym: _institutionAcronym,
    }), [_institutionAcronym]);
    return (_jsx(InstitutionContext.Provider, { value: value, children: children }));
};
const useInstitution = () => {
    const { institutionAcronym } = useContext(InstitutionContext);
    const _institutionAcronym = useMemo(() => institutionAcronym(), [institutionAcronym]);
    return {
        institutionAcronym: _institutionAcronym,
    };
};
export default useInstitution;
